import timeLine from '../Timeline/Timeline.vue'

export default {
  name: 'UserInfo',
  components: { timeLine },
  computed: {
    devices () {
      return this.user.devices || []
    },
    devicesCount () {
      return this.devices.length || 0
    },
    groups () {
      return this.user.groups || []
    },
    groupsCount () {
      return this.groups.length || 0
    }
  },
  methods: {
    getGroupName (group) {
      return (group.properties && group.properties.displayName) || group.name
    }
  },
  props: {
    loading: {
      default: false,
      type: Boolean
    },
    user: {
      default: () => ({ devices: [], groups: [] }),
      type: Object
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/UserInfo/UserInfo.js